import Axios from 'axios';
import React, { useEffect, useState } from 'react';
import MediaItem from '../MediaItem/MediaItem.jsx';
import { Spinner } from 'react-bootstrap';

export default function Home({ setIsLogged }) {
  const [trendingMovies, setTrendingMovies] = useState([]);
  const [trendingTv, setTrendingTv] = useState([]);
  const [trendingPeople, setTrendingPeople] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  async function getTrending(mediaType, callback) {
    let { data } = await Axios.get(
      `https://api.themoviedb.org/3/trending/${mediaType}/week?api_key=86a23d94aa6567f63245ba13568ede00`
    );
    callback(data.results);
    mediaType === 'person' && setIsLoading(false);
  }

  useEffect(() => {
    getTrending('movie', setTrendingMovies);
    getTrending('tv', setTrendingTv);
    getTrending('person', setTrendingPeople);
    setIsLogged(true);
  }, []);

  return isLoading ? (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <Spinner animation="grow" variant="secondary" style={{ width: '200px', height: '200px', padding: 30 }} />
    </div>
  ) : (
    <div className="container">
      <div className="row py-3">
        <div className="col-md-4 d-flex align-items-center mb-4 mb-md-0">
          <div>
            <div className="brdr w-25 mb-3"></div>
            <h1 className="h4">Trending Movies <br /> To Watch Right Now</h1>
            <p className="py-2 text-secondary">Watched Movies To Watch Right Now</p>
            <div className="brdr w-100 mt-3"></div>
          </div>
        </div>
        {trendingMovies.slice(0, 10).map((item, index) => (
          <div key={index} className="col-lg-2 col-md-4 col-sm-12 mb-3">
            <MediaItem item={item} />
          </div>
        ))}
      </div>

      <div className="row py-5">
        <div className="col-md-4 d-flex align-items-center mb-4 mb-md-0">
          <div>
            <div className="brdr w-25 mb-3"></div>
            <h1 className="h4">Trending TV Shows <br /> To Watch Right Now</h1>
            <p className="py-2 text-secondary">Watched TV Shows To Watch Right Now</p>
            <div className="brdr w-100 mt-3"></div>
          </div>
        </div>
        {trendingTv.slice(0, 10).map((item, index) => (
          <div key={index} className="col-lg-2 col-md-4 col-sm-12 mb-3">
            <MediaItem item={item} />
          </div>
        ))}
      </div>

      <div className="row py-5">
        <div className="col-md-4 d-flex align-items-center mb-4 mb-md-0">
          <div>
            <div className="brdr w-25 mb-3"></div>
            <h1 className="h4">Trending People <br /> To Watch Right Now</h1>
            <p className="py-2 text-secondary">Watched People To Watch Right Now</p>
            <div className="brdr w-100 mt-3"></div>
          </div>
        </div>
        {trendingPeople.slice(0, 10).map((item, index) => (
          <div key={index} className="col-lg-2 col-md-4 col-sm-12 mb-3">
            <MediaItem item={item} />
          </div>
        ))}
      </div>
    </div>
  );
}
